var map = {
	"./en/translation.json": [
		"../assets/i18n/en/translation.json",
		"assets_i18n_en_translation_json"
	],
	"./nl/translation.json": [
		"../assets/i18n/nl/translation.json",
		"assets_i18n_nl_translation_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../assets/i18n lazy recursive ^\\.\\/.*\\/.*\\.json$";
module.exports = webpackAsyncContext;